/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Resume_Builder_ContentInputs */

const en_help_resume_builder_content = /** @type {(inputs: Help_Resume_Builder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose from professional templates, use AI tailoring to match specific job descriptions, check your ATS compatibility score, and export as PDF or DOCX.`)
};

const de_help_resume_builder_content = /** @type {(inputs: Help_Resume_Builder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie aus professionellen Vorlagen, nutzen Sie KI-Optimierung für bestimmte Stellenbeschreibungen, prüfen Sie Ihre ATS-Kompatibilität und exportieren Sie als PDF oder DOCX.`)
};

const fr_help_resume_builder_content = /** @type {(inputs: Help_Resume_Builder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez parmi des modèles professionnels, utilisez l'optimisation IA pour des descriptions de poste spécifiques, vérifiez votre score ATS et exportez en PDF ou DOCX.`)
};

const es_help_resume_builder_content = /** @type {(inputs: Help_Resume_Builder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija entre plantillas profesionales, use la optimización con IA para descripciones de empleo específicas, verifique su compatibilidad ATS y exporte como PDF o DOCX.`)
};

const it_help_resume_builder_content = /** @type {(inputs: Help_Resume_Builder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli tra modelli professionali, usa l'ottimizzazione IA per descrizioni di lavoro specifiche, verifica la compatibilità ATS ed esporta in PDF o DOCX.`)
};

const nl_help_resume_builder_content = /** @type {(inputs: Help_Resume_Builder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies uit professionele sjablonen, gebruik AI-optimalisatie voor specifieke vacatures, controleer uw ATS-compatibiliteit en exporteer als PDF of DOCX.`)
};

const pl_help_resume_builder_content = /** @type {(inputs: Help_Resume_Builder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz spośród profesjonalnych szablonów, użyj optymalizacji AI dla konkretnych opisów stanowisk, sprawdź kompatybilność ATS i eksportuj jako PDF lub DOCX.`)
};

const fi_help_resume_builder_content = /** @type {(inputs: Help_Resume_Builder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse ammattimaisista malleista, käytä tekoälyoptimointia tiettyihin työpaikkakuvauksiin, tarkista ATS-yhteensopivuutesi ja vie PDF- tai DOCX-muodossa.`)
};

const da_help_resume_builder_content = /** @type {(inputs: Help_Resume_Builder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg mellem professionelle skabeloner, brug AI-tilpasning til specifikke jobbeskrivelser, tjek din ATS-kompatibilitet, og eksporter som PDF eller DOCX.`)
};

const sv_help_resume_builder_content = /** @type {(inputs: Help_Resume_Builder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj bland professionella mallar, använd AI-optimering för specifika jobbannonser, kontrollera din ATS-kompatibilitet och exportera som PDF eller DOCX.`)
};

/**
* | output |
* | --- |
* | "Choose from professional templates, use AI tailoring to match specific job descriptions, check your ATS compatibility score, and export as PDF or DOCX." |
*
* @param {Help_Resume_Builder_ContentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const help_resume_builder_content = /** @type {((inputs?: Help_Resume_Builder_ContentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Resume_Builder_ContentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_help_resume_builder_content(inputs)
	if (locale === "fr") return fr_help_resume_builder_content(inputs)
	if (locale === "es") return es_help_resume_builder_content(inputs)
	if (locale === "it") return it_help_resume_builder_content(inputs)
	if (locale === "nl") return nl_help_resume_builder_content(inputs)
	if (locale === "pl") return pl_help_resume_builder_content(inputs)
	if (locale === "fi") return fi_help_resume_builder_content(inputs)
	if (locale === "da") return da_help_resume_builder_content(inputs)
	if (locale === "sv") return sv_help_resume_builder_content(inputs)
	return en_help_resume_builder_content(inputs)
});